export const INIT = (state) => {
  state.inited = true
}

export const ONLINE = (state) => {
  state.online = true
}

export const OFFLINE = (state) => {
  state.online = false
}
